export const STORE_FLASH_INFO_ADDED_SENT = 'store_flash_info_added_sent';
export const STORE_FLASH_INFO_CATEGORIES_LOADED = 'store_flash_info_categories_loaded';
export const STORE_FLASH_INFO_DELETED = 'store_flash_info_deleted';
export const STORE_FLASH_INFO_FAILED = 'store_flash_info_failed';
export const STORE_FLASH_INFO_PENDING = 'store_flash_info_pending';
export const STORE_FLASH_INFO_LOADED = 'store_flash_info_loaded';
export const STORE_FLASH_INFO_RESET_STATUS = 'store_flash_info_reset_status';
export const STORE_FLASH_INFO_SENDING = 'store_flash_info_sending';
export const STORE_FLASH_INFO_UPDATED_SENT = 'store_flash_info_updated_sent';
